export default __webpack_public_path__ + "static/media/Treatment_Grand_stretch.e40f6083.png";